import React, { useState } from "react";
import { withRedux } from "helpers";
import { sendNotification } from "apis";
import { Input } from "vComponents";
import { Input as InputCheckBox } from "components";
import { SelectOptions, DatePicker } from "components";
import { Button, FlexRow } from "appStyles";
import AlertModal from "../../components/Tools/AlertModal";
import SendIcon from "@material-ui/icons/Send";
import ScheduleIcon from "@material-ui/icons/Schedule";

// import { set } from "react-ga";

function NotificationForm({
  activeApp: {
    id: appId,
    view: { templates: templateIds },
  },
  hideForm,
  fetchNotifications,
}) {
  const defaultPayload = {
    appId,
    title: "",
    text: "",
    isPushNotification: true,
    templateId: "",
    scheduled: false,
    nextSendDate: null,
    repeatingFrequency: null,
    repeatingInterval: null,
    endDate: null,
    showPushNotificationOverviewPage: false,
  };

  const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // const repeatingFrequencyDefault = 1;
  // const repeatingIntervalDefault = "weeks";
  const currentTimeZoneShortName = new Date()
    .toLocaleTimeString("en-us", { timeZoneName: "short" })
    .split(" ")[2];
  const [payload, setPayload] = useState(defaultPayload);
  const [error, setError] = useState("");
  const [timeZone, setTimeZone] = useState(currentTimeZone);
  const [success, setSuccess] = useState(false);

  // const [rFreq, setRFreq] = useState(repeatingFrequencyDefault);
  // const [rInterval, setRInterval] = useState(repeatingIntervalDefault);

  const zeroPad = (input, length) => {
    return (Array(length + 1).join("0") + input).slice(-length);
  };

  const formatDateString = (epochTime) => {
    const currDate = new Date(epochTime);
    const convertedTime = new Date(
      currDate.toLocaleString("en-US", {
        timeZone,
      })
    );
    const diff = currDate.getTime() - convertedTime.getTime();

    const dateObject = new Date(currDate.getTime() + diff);
    const yyyy = dateObject.getUTCFullYear();
    const MM = zeroPad(dateObject.getMonth() + 1, 2);
    const dd = zeroPad(dateObject.getUTCDate(), 2);
    const HH = zeroPad(dateObject.getUTCHours(), 2);
    const mm = zeroPad(dateObject.getUTCMinutes(), 2);

    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:00`;
  };

  const update = (key) => (e) => {
    setError("");
    let value;
    // console.log("got key in update " + key);
    if (e === null) {
      // console.log("got null value in update");
      value = null;
    } else {
      if (key === "showPushNotificationOverviewPage") {
        if (e === 0) {
          value = false;
        } else {
          value = true;
        }
      } else {
        value = e.currentTarget ? e.currentTarget.value : e;
      }

      // console.log("got value in update " + value);
    }
    setPayload({
      ...payload,
      [key]: value,
    });
  };

  const timeZoneOptions = [
    {
      value: currentTimeZone,
      label: currentTimeZoneShortName,
    },
    {
      value: "America/New_York",
      label: "EST",
    },
  ];

  const scheduledOptions = [
    {
      value: false,
      label: "Now",
    },
    {
      value: true,
      label: "Scheduled",
    },
  ];

  const repeatingIntervalOptions = [
    {
      value: "months",
      label: "Month(s)",
    },
    {
      value: "weeks",
      label: "Week(s)",
    },
    // {
    //   value: null,
    //   label: "None"
    // }
  ];

  const repeatingFrequencyOptions = [
    {
      value: 1,
      label: 1,
    },
    {
      value: 2,
      label: 2,
    },
    {
      value: 3,
      label: 3,
    },
    {
      value: 4,
      label: 4,
    },
    {
      value: 5,
      label: 5,
    },
    {
      value: 6,
      label: 6,
    },
    {
      value: 7,
      label: 7,
    },
    {
      value: 8,
      label: 8,
    },
    {
      value: 9,
      label: 9,
    },
    {
      value: 10,
      label: 10,
    },
    {
      value: 11,
      label: 11,
    },
    {
      value: 12,
      label: 12,
    },
  ];

  const cadenceOptions = [
    {
      value: false,
      label: "One Time",
    },
    {
      value: true,
      label: "Recurring",
    },
  ];

  const templateIdOptions = templateIds
    ? templateIds.map(({ id, pageName }) => ({
        value: id,
        label: `${pageName}`,
      }))
    : [];

  const notificationType = [
    {
      value: true,
      label: "Push and In App Notification",
    },
    {
      value: false,
      label: "In App Notification Only",
    },
  ];

  const selectorStyle = {
    marginLeft: "20px",
  };

  const selectorTitle = {
    width: "150px",
    paddingTop: "10px",
  };

  const rowStyle = {
    display: "flex",
    margin: "10px 0px",
  };

  const updateRepeatingFrequency = (repeatingFrequency) => {
    if (!repeatingFrequency) {
      // console.log("updating repeating frequency if neccessary");
      setPayload({
        ...payload,
        repeatingFrequency: 1,
      });
    }
  };

  const updateRepeatingInterval = (repeatingInterval) => {
    if (!repeatingInterval) {
      // console.log("updating repeating interval if neccessary");
      setPayload({
        ...payload,
        repeatingInterval: "weeks",
      });
    }
  };

  const renderScheduledOptions = (
    nextSendDate,
    repeatingFrequency,
    repeatingInterval,
    cadence,
    endDate
  ) => {
    if (cadence == true) {
      updateRepeatingFrequency(repeatingFrequency);
      updateRepeatingInterval(repeatingInterval);
    }
    return (
      <React.Fragment>
        <div style={rowStyle}>
          <p style={selectorTitle}>Cadence: </p>
          <SelectOptions
            style={selectorStyle}
            width="200px"
            value={cadence}
            setValue={update("cadence")}
            options={cadenceOptions}
          />
        </div>
        <div style={rowStyle}>
          <p style={selectorTitle}>Timezone: </p>
          <SelectOptions
            style={selectorStyle}
            width="200px"
            value={timeZone}
            setValue={(tz) => setTimeZone(tz)}
            options={timeZoneOptions}
          />
        </div>
        {!cadence && (
          <div style={rowStyle}>
            <p style={selectorTitle}>Send Date: </p>
            <DatePicker
              datePickerProps={{
                showTimeSelect: true,
                timeFormat: "hh:mm a",
                timeIntervals: 10,
                timeCaption: "time",
                dateFormat: "MM/dd/yyyy hh:mm a",
                style: {
                  marginLeft: "43px",
                  innerWidth: "200px",
                  innerBackgroundPosition: "175px center",
                  marginTop: "10px",
                },
              }}
              selected={nextSendDate}
              onChange={update("nextSendDate")}
            />
          </div>
        )}
        {cadence && (
          <div>
            <div style={rowStyle}>
              <p style={selectorTitle}>Repeat Every: </p>
              <SelectOptions
                style={selectorStyle}
                width="200px"
                value={repeatingFrequency ? repeatingFrequency : 1}
                options={repeatingFrequencyOptions}
                setValue={update("repeatingFrequency")}
                // isDisabled={!Boolean(repeatingInterval)}
              />
              <SelectOptions
                style={selectorStyle}
                width="200px"
                value={repeatingInterval ? repeatingInterval : "weeks"}
                options={repeatingIntervalOptions}
                setValue={update("repeatingInterval")}
              />
            </div>
            <div style={rowStyle}>
              <p style={selectorTitle}>Send Date: </p>
              <DatePicker
                datePickerProps={{
                  showTimeSelect: true,
                  timeFormat: "hh:mm a",
                  timeIntervals: 10,
                  timeCaption: "time",
                  dateFormat: "MM/dd/yyyy hh:mm a",
                  style: {
                    marginLeft: "43px",
                    marginTop: "10px",
                    innerWidth: "200px",
                    innerBackgroundPosition: "175px center",
                  },
                }}
                selected={nextSendDate}
                onChange={update("nextSendDate")}
              />
            </div>
            <div style={rowStyle}>
              <p style={selectorTitle}>End Date: </p>
              <DatePicker
                datePickerProps={{
                  showTimeSelect: true,
                  timeFormat: "hh:mm a",
                  timeIntervals: 10,
                  timeCaption: "time",
                  dateFormat: "MM/dd/yyyy hh:mm a",
                  style: {
                    marginLeft: "43px",
                    marginTop: "10px",
                  },
                }}
                selected={endDate}
                onChange={update("endDate")}
              />
            </div>
          </div>
        )}
      </React.Fragment>
    );
  };
  const submitSendRequest = async () => {
    const { nextSendDate, endDate } = payload;
    // console.log(payload);
    try {
      const result = await sendNotification({
        ...payload,
        nextSendDate: nextSendDate ? formatDateString(nextSendDate) : null,
        endDate: endDate ? formatDateString(endDate) : null,
        repeatingFrequency: payload.repeatingInterval
          ? payload.repeatingFrequency
          : null,
      });
      setSuccess(true);
      setPayload(defaultPayload);
      fetchNotifications(result.id);
    } catch (e) {
      setError(e);
    }
  };

  const submitScheduleRequest = async () => {
    const { nextSendDate, endDate } = payload;

    try {
      const result = await sendNotification({
        ...payload,
        nextSendDate: nextSendDate ? formatDateString(nextSendDate) : null,
        endDate: endDate ? formatDateString(endDate) : null,
        repeatingFrequency: payload.repeatingInterval
          ? payload.repeatingFrequency
          : null,
      });
      setPayload(defaultPayload);
      hideForm();
      fetchNotifications(result.id);
    } catch (e) {
      setError(e);
    }
  };

  const renderSuccessModal = () => {
    if (!success) {
      return null;
    }

    return (
      <AlertModal
        title="Notification Sent!"
        buttons={
          <a
            onClick={() => {
              setSuccess(false);
              hideForm();
            }}
            key="discardButton"
            variant="contained"
            style={{
              cursor: "pointer",
              backgroundColor: "white",
              color: "#89d2d3",
              fontWeight: "500",
              lineHeight: "1.75",
              borderRadius: "4px",
              letterSpacing: "0.02857em",
              textTransform: "uppercase",
              paddingLeft: "10px",
              fontSize: "0.9375rem",
            }}
          >
            Great!
          </a>
        }
        render={success}
      ></AlertModal>
    );
  };

  const renderForm = () => {
    const {
      isPushNotification,
      templateId,
      scheduled,
      nextSendDate,
      repeatingFrequency,
      cadence,
      repeatingInterval,
      endDate,
      showPushNotificationOverviewPage,
    } = payload;
    // console.log("push bool: " + showPushNotificationOverviewPage);

    return (
      <React.Fragment>
        <Input
          style={{
            width: "98%",
            margin: "10px 0px",
          }}
          maxLength="50"
          onChange={update("title")}
          placeholder="Notification Title"
        />
        <Input
          style={{
            width: "98%",
            margin: "10px 0px",
          }}
          onChange={update("text")}
          placeholder="Notification Body"
        ></Input>

        <div style={rowStyle}>
          <p style={selectorTitle}>Notification Type: </p>
          <SelectOptions
            style={selectorStyle}
            width="350px"
            value={isPushNotification}
            options={notificationType}
            setValue={update("isPushNotification")}
          />
        </div>

        <div style={rowStyle}>
          <p style={selectorTitle}>Open to Page: </p>
          <SelectOptions
            style={selectorStyle}
            width="350px"
            value={templateId}
            options={templateIdOptions}
            setValue={update("templateId")}
          />
        </div>
        <div
          style={{
            marginTop: "5px",
            marginBottom: "5px",
            display: "flex",
            margin: "10px 0px",
          }}
        >
          <InputCheckBox
            type="checkbox"
            name="showPushNotificationOverviewPage"
            onChange={update("showPushNotificationOverviewPage")}
            defaultValue={showPushNotificationOverviewPage}
            margin="0px"
            marginRight="156px"
          />
          <p>
            Open to notifications overview page before going to page selected
            above (if any).
          </p>
        </div>

        <div style={rowStyle}>
          <p style={selectorTitle}>Send: </p>
          <SelectOptions
            style={selectorStyle}
            width="200px"
            value={scheduled}
            options={scheduledOptions}
            setValue={update("scheduled")}
          />
        </div>
        {scheduled
          ? renderScheduledOptions(
              nextSendDate,
              repeatingFrequency,
              repeatingInterval,
              cadence,
              endDate
            )
          : null}
        {scheduled && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <FlexRow width="auto">
              {/* <Button
            background='#F17F7F'
          >Delete</Button> */}
              <Button
                onClick={submitScheduleRequest}
                background="#89D2D3"
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  fontStyle: "normal",
                  fontStretch: "normal",
                  lineHeight: "normal",
                  letterSpacing: "normal",
                  textTransform: "none",
                  boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                  display: "inline-flex",
                  alignItems: "center",
                  borderRadius: "5.5px",
                }}
              >
                <ScheduleIcon style={{ marginRight: "5px" }}></ScheduleIcon>
                Schedule
              </Button>
            </FlexRow>
          </div>
        )}
        {!scheduled && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <FlexRow width="auto">
              {/* <Button
            background='#F17F7F'
          >Delete</Button> */}
              <Button
                onClick={submitSendRequest}
                background="#89D2D3"
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  fontStyle: "normal",
                  fontStretch: "normal",
                  lineHeight: "normal",
                  letterSpacing: "normal",
                  textTransform: "none",
                  boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                  display: "inline-flex",
                  alignItems: "center",
                  borderRadius: "5.5px",
                }}
              >
                <SendIcon style={{ marginRight: "5px" }}></SendIcon>
                Send Now
              </Button>
            </FlexRow>
          </div>
        )}
      </React.Fragment>
    );
  };

  return (
    <div>
      <div
        style={{
          left: " 318px",
          top: " 344px",
          padding: "20px",
        }}
      >
        <p>New Notification</p>
        {error && (
          <p
            style={{
              color: "red",
            }}
          >
            {error}
          </p>
        )}
        {renderForm()}
        {renderSuccessModal()}
      </div>
    </div>
  );
}

export default withRedux(NotificationForm);
